import {
  PAGINATION_ACTIONS,
} from 'src/actions/constants';

const createPaginationReducer = (reducerLabel, {
  sortBy,
  descendingOrder = false,
  currentPageNumber = 1,
  nextOrPrev = 'first',
  isNextPresent = true,
  resultPerPage = 100,
}) => {
  const defaultState = {
    data: [],
    isLoading: true,
    errorMessage: null,
    selectedFilters: {
      descendingOrder,
      sortBy,
    },
    appliedFilters: {
      descendingOrder,
      sortBy,
    },
    pagination: {
      currentPageNumber,
      resultPerPage,
      nextOrPrev,
      isNextPresent,
      lastItemIdPrev: undefined,
      lastItemIdNext: undefined,
      lastSortedColumnValuePrev: undefined,
      lastSortedColumnValueNext: undefined,
      // lastRowId: null,
    },
    prevPagination: {
      currentPageNumber,
      resultPerPage,
      isNextPresent,
      nextOrPrev: 'prev',
    },
  };

  const getPaginationData = (data) => {
    return Object.keys(defaultState.pagination)
      .filter((key) => key !== 'resultPerPage')
      .reduce((acc, cur) => {
        acc[cur] = data?.[cur] || data?.paginationData?.[cur];
        return acc;
      }, {});
  };

  return (state = defaultState, action) => {
    switch (action.type) {
      case PAGINATION_ACTIONS(reducerLabel).ENABLE_LOADING: {
        return {
          ...state,
          isLoading: true,
        };
      }

      case PAGINATION_ACTIONS(reducerLabel).DISABLE_LOADING: {
        return {
          ...state,
          isLoading: false,
        };
      }

      case PAGINATION_ACTIONS(reducerLabel).SET_FILTER: {
        return {
          ...state,
          selectedFilters: {
            ...state.selectedFilters,
            ...action.data,
          },
        };
      }

      case PAGINATION_ACTIONS(reducerLabel).CANCEL_FILTER: {
        return {
          ...state,
          selectedFilters: {
            ...state.appliedFilters,
          },
        };
      }

      case PAGINATION_ACTIONS(reducerLabel).APPLY_FILTER: {
        return {
          ...state,
          appliedFilters: {
            ...state.appliedFilters,
            ...state.selectedFilters,
          },
        };
      }

      case PAGINATION_ACTIONS(reducerLabel).SET_PAGINATION: {
        return {
          ...state,
          pagination: {
            ...state.pagination,
            ...action.data,
          },
        };
      }

      case PAGINATION_ACTIONS(reducerLabel).RESET_FILTER: {
        return {
          ...state,
          appliedFilters: defaultState.appliedFilters,
          selectedFilters: defaultState.selectedFilters,
        };
      }

      case PAGINATION_ACTIONS(reducerLabel).RESET_PAGINATION: {
        return {
          ...state,
          pagination: {
            ...defaultState.pagination,
            resultPerPage: state.pagination.resultPerPage,
          },
        };
      }

      case PAGINATION_ACTIONS(reducerLabel).SET_PREV_PAGINATION: {
        return {
          ...state,
          pagination: state.prevPagination,
        };
      }

      case PAGINATION_ACTIONS(reducerLabel).PAGINATION_LOADED: {
        return {
          ...state,
          data: action.data?.data ? action.data.data : (action.data ? action.data : []),
          prevPagination: {
            ...state.pagination,
          },
          pagination: {
            ...state.pagination,
            ...getPaginationData(action.data),
          },
          errorMessage: null,
        };
      }
      case PAGINATION_ACTIONS(reducerLabel).PAGINATION_ERROR: {
        return {
          ...state,
          data: null,
          errorMessage: action.errorMessage,
        };
      }
      default: {
        return state;
      }
    }
  };
};

export interface PaginationReducerType {
  name: string;
  label: string;
  args: {};
}

export const PAGINATION_REDUCERS: {
  rfqRemarks: PaginationReducerType,
  rfqBulkRequest: PaginationReducerType,
  seDocuments: PaginationReducerType,
  chargeMaster: PaginationReducerType
  rfqRegionLineItems: PaginationReducerType,
} = ({
  rfqRemarks: {
    name: 'rfqRemarksPaginationReducer', // becomes the name of the reducer
    label: 'RFQ_REMARKS', // suffixed after every action identifier
    args: { // passed to create reducer
      resultPerPage: 10,
    },
  },
  rfqBulkRequest: {
    name: 'rfqBulkRequestPaginationReducer', // becomes the name of the reducer
    label: 'RFQ_BULK_REQUEST', // suffixed after every action identifier
    args: { // passed to create reducer
      resultPerPage: 10,
    },
  },
  rfqRegionLineItems: {
    name: 'rfqRegionLineItemPaginationReducer', // becomes the name of the reducer
    label: 'RFQ_REGION_LINE_ITEMS', // suffixed after every action identifier
    args: { // passed to create reducer
      resultPerPage: 10,
      descendingOrder: true,
    },
  },
  seDocuments: {
    name: 'seDocumentsPaginationReducer',
    label: 'SE_DOCUMENTS',
    args: { // passed to create reducer
      resultPerPage: 100,
    },
  },
  chargeMaster: {
    name: 'chargeMasterPaginationReducer',
    label: 'CHARGE_MASTER',
    args: { // passed to create reducer
      resultPerPage: 25,
    },
  },
});

export default () => Object.keys(PAGINATION_REDUCERS).reduce((res, cur) => {
  const reducer = PAGINATION_REDUCERS[cur];
  res[reducer.name] = createPaginationReducer(reducer.label, reducer.args);
  return res;
}, {});
